import { CallStateEnum } from '@models/call-state.model.ts';
import { SnackbarType } from '@models/app-snackbar.model.ts';
import useSnackbarStore from '@store/snackbar-store/snackbar.store.ts';
import axios from 'axios';
import {
  SERIES_INITIAL_STATE,
  SeriesActionParams
} from '@modules/entertainment/pages/series/store/series.model.ts';
import {
  createGenre,
  deleteGenre,
  editGenre,
  getGenres
} from '@api/entertainment-api/entertainment-api.ts';
import { GenresEnum } from '@modules/entertainment/models/entertainment.models.ts';
import {
  createSeries,
  deleteSerie,
  deleteSeriesMany,
  editSeriesRow
} from '@api/entertainment-api/series-api.ts';

const { showSnackbar } = useSnackbarStore.getState();

export const seriesSlice = (set: any, getState: any) => ({
  ...SERIES_INITIAL_STATE,
  getGenreList: async () => {
    try {
      const genreData = await getGenres(GenresEnum.Series);

      const genreList = genreData.map((genre) => ({
        id: genre?._id,
        name: genre.name,
        image: genre.image
      }));

      set({
        genreList
      });
    } catch (error) {
      set({ callState: CallStateEnum.Error });
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message;
        showSnackbar(message, SnackbarType.Error);
      }
    }
  },

  createRow: async ({ data, state, handleClose }: SeriesActionParams) => {
    set({ callState: CallStateEnum.Loading });
    try {
      const response = await createSeries(data);
      set({ callState: CallStateEnum.Loaded });
      handleClose?.();
      state.setApiFunctionAndFetchData(state.apiFunction);
      showSnackbar('snackbar_success_series_text', SnackbarType.Success);
      return response;
    } catch (error) {
      set({ callState: CallStateEnum.Error });
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message;
        showSnackbar(message, SnackbarType.Error);
      }

      return null;
    }
  },

  editRow: async ({ data, id, state, handleClose }: SeriesActionParams) => {
    set({ callState: CallStateEnum.Loading });
    try {
      await editSeriesRow(data, id);
      set({ callState: CallStateEnum.Loaded });
      handleClose?.();
      state.setApiFunctionAndFetchData(state.apiFunction);
      showSnackbar('snackbar_update_series_text', SnackbarType.Success);
    } catch (error) {
      set({ callState: CallStateEnum.Error });
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message;
        showSnackbar(message, SnackbarType.Error);
      }
    }
  },

  deleteRow: async ({ id, state, handleClose }: SeriesActionParams) => {
    set({ callState: CallStateEnum.Loading });
    try {
      if (id instanceof Array) {
        await deleteSeriesMany(id);
      } else {
        await deleteSerie(id);
      }
      set({ callState: CallStateEnum.Loaded });
      handleClose?.();
      state.setApiFunctionAndFetchData(state.apiFunction);
      showSnackbar('snackbar_delete_series_text', SnackbarType.Success);
    } catch (error) {
      set({ callState: CallStateEnum.Error });
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message;
        showSnackbar(message, SnackbarType.Error);
      }
    }
  },

  createGenre: async ({ data, handleClose }: SeriesActionParams) => {
    set({ genreCallState: CallStateEnum.Loading });
    try {
      await createGenre(data);
      await getState().getGenreList();
      set({ genreCallState: CallStateEnum.Loaded });
      handleClose?.();
    } catch (error) {
      set({ genreCallState: CallStateEnum.Error });
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message;
        showSnackbar(message, SnackbarType.Error);
      }

      throw error;
    }
  },

  editGenre: async ({ data, id, handleClose }: SeriesActionParams) => {
    set({ genreCallState: CallStateEnum.Loading });
    try {
      await editGenre(data as any, id);
      await getState().getGenreList();
      set({ genreCallState: CallStateEnum.Loaded });
      handleClose?.();
    } catch (error) {
      set({ genreCallState: CallStateEnum.Error });
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message;
        showSnackbar(message, SnackbarType.Error);
      }
    }
  },

  deleteGenre: async ({ id, handleClose }: SeriesActionParams) => {
    set({ genreCallState: CallStateEnum.Loading });
    try {
      await deleteGenre(id);
      await getState().getGenreList();
      set({ genreCallState: CallStateEnum.Loaded });
      handleClose?.();
    } catch (error) {
      set({ genreCallState: CallStateEnum.Error });
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message;
        showSnackbar(message, SnackbarType.Error);
      }
    }
  }
});
